module.exports = __webpack_public_path__ + "img/search_pressed.2a493397.png";